// SEO Metadata for all pages
export const seoMetadata = {
  home: {
    title: 'Bombay Home Gallery - Best Tiles, Bathroom & Plumbing Showroom in Lucknow',
    description: 'Lucknow\'s most trusted showroom for premium tiles, bathroom fittings, sanitary ware & plumbing essentials. Expert guidance from a civil engineer. 10+ years experience. Visit our Hardoi Road showroom or call 9321233008.',
    keywords: 'tiles showroom lucknow, bathroom fittings lucknow, plumbing shop lucknow, vitrified tiles lucknow, ceramic tiles lucknow, sanitary ware lucknow, best tiles shop lucknow, floor tiles lucknow, wall tiles lucknow, bathroom tiles lucknow, kitchen tiles lucknow, cp fittings lucknow, pipes and fittings lucknow, building materials lucknow, home interiors lucknow, bombay home gallery',
    canonical: '/'
  },
  about: {
    title: 'About Us - Bombay Home Gallery | Material Consultant in Lucknow',
    description: 'Founded by Akhand Pratap, Civil Engineer with Master\'s in Construction Management. Get professional guidance for tiles, bathroom fittings & plumbing. 10+ years of trusted service in Lucknow.',
    keywords: 'material consultant lucknow, civil engineer consultant lucknow, construction materials expert, building materials guidance, tiles expert lucknow, bathroom design consultant, akhand pratap, bombay home gallery founder',
    canonical: '/about'
  },
  products: {
    title: 'Premium Tiles, Bathroom & Plumbing Products | Bombay Home Gallery Lucknow',
    description: 'Explore premium vitrified tiles, ceramic tiles, designer washbasins, CP fittings, sanitary ware & plumbing pipes. Brands: Astral, Birla Opus, Roff, Parryware, Plumber. Best prices in Lucknow.',
    keywords: 'vitrified tiles lucknow, ceramic tiles lucknow, floor tiles lucknow, wall tiles lucknow, bathroom tiles lucknow, kitchen tiles lucknow, marble tiles lucknow, granite tiles lucknow, designer tiles lucknow, washbasin lucknow, toilet seat lucknow, bathroom vanity lucknow, cp fittings lucknow, taps and faucets lucknow, shower fittings lucknow, astral pipes lucknow, birla opus tiles, roff adhesive lucknow, parryware sanitary lucknow, plumbing pipes lucknow, pvc pipes lucknow, cpvc pipes lucknow',
    canonical: '/products'
  },
  whyChooseUs: {
    title: 'Why Choose Bombay Home Gallery | Best Tiles Shop in Lucknow',
    description: 'Discover why 5000+ customers trust Bombay Home Gallery. Expert guidance, premium quality products, competitive prices & after-sales support. One-stop solution for tiles, bathroom & plumbing.',
    keywords: 'best tiles shop lucknow, trusted tiles showroom, quality bathroom fittings, affordable tiles lucknow, tiles with installation, bathroom renovation lucknow, home building materials, construction materials shop lucknow',
    canonical: '/why-choose-us'
  },
  contact: {
    title: 'Contact Us - Visit Bombay Home Gallery Showroom | Hardoi Road Lucknow',
    description: 'Visit our showroom at Hardoi Road, Mahipatmau, Lucknow 226003. Call 9321233008 or WhatsApp for free consultation. Open all days 10 AM - 8:30 PM. Expert guidance for your home project.',
    keywords: 'tiles showroom hardoi road, building materials lucknow contact, tiles shop mahipatmau, showroom lucknow 226003, tiles consultation lucknow, free tiles consultation, home visit lucknow',
    canonical: '/contact'
  },
  ebook: {
    title: 'Free Homebuilding Guide - Avoid Costly Mistakes | Bombay Home Gallery',
    description: 'Download our Premium Homebuilding Guide. Learn how to save lakhs on tiles, bathroom fittings & plumbing. Expert tips from a Civil Engineer. Free PDF download.',
    keywords: 'homebuilding guide, tiles buying guide, bathroom renovation tips, plumbing guide, construction tips, save money on tiles, home building mistakes, material selection guide, tiles selection tips',
    canonical: '/ebook'
  }
};

// Structured Data for Local Business SEO
export const structuredData = {
  localBusiness: {
    '@context': 'https://schema.org',
    '@type': 'HomeAndConstructionBusiness',
    '@id': 'https://bombayhomegallery.com/#business',
    name: 'Bombay Home Gallery',
    alternateName: 'BHG Lucknow',
    description: 'Premium tiles, bathroom fittings, sanitary ware and plumbing solutions showroom in Lucknow. Expert guidance from a civil engineer for all your home building needs.',
    image: [
      'https://bhg-preview-build.preview.emergentagent.com/bhg-logo.png',
      'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c'
    ],
    logo: 'https://bhg-preview-build.preview.emergentagent.com/bhg-logo.png',
    url: 'https://bombayhomegallery.com',
    telephone: '+919321233008',
    email: 'bombayhomegallery@gmail.com',
    priceRange: '₹₹',
    currenciesAccepted: 'INR',
    paymentAccepted: 'Cash, UPI, Credit Card, Debit Card',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Hardoi road, opposite Azad patakhe, Haji Colony, Mahipatmau',
      addressLocality: 'Lucknow',
      addressRegion: 'Uttar Pradesh',
      postalCode: '226003',
      addressCountry: 'IN'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 26.8467,
      longitude: 80.9462
    },
    hasMap: 'https://www.google.com/maps?cid=bombayhomegallery',
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        opens: '10:00',
        closes: '20:30'
      }
    ],
    sameAs: [
      'https://www.facebook.com/profile.php?id=61573024285498',
      'https://www.instagram.com/bombayhomegallery'
    ],
    areaServed: [
      {
        '@type': 'City',
        name: 'Lucknow',
        '@id': 'https://en.wikipedia.org/wiki/Lucknow'
      },
      {
        '@type': 'State',
        name: 'Uttar Pradesh'
      }
    ],
    founder: {
      '@type': 'Person',
      name: 'Akhand Pratap',
      jobTitle: 'Founder & Material Consultant',
      description: 'Civil Engineer with Master\'s in Construction Management'
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.8',
      reviewCount: '150',
      bestRating: '5',
      worstRating: '1'
    }
  },
  products: {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Products at Bombay Home Gallery',
    description: 'Premium tiles, bathroom fittings, and plumbing products',
    numberOfItems: 3,
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: {
          '@type': 'Product',
          name: 'Tiles & Surfaces',
          description: 'Vitrified tiles, ceramic tiles, floor tiles, wall tiles, kitchen tiles, bathroom tiles, outdoor tiles',
          brand: ['Birla Opus', 'Asian Granito', 'Kajaria']
        }
      },
      {
        '@type': 'ListItem',
        position: 2,
        item: {
          '@type': 'Product',
          name: 'Bathroom & Sanitary Solutions',
          description: 'Washbasins, toilets, bathroom vanities, CP fittings, showers, bathtubs',
          brand: ['Parryware', 'Hindware', 'Cera']
        }
      },
      {
        '@type': 'ListItem',
        position: 3,
        item: {
          '@type': 'Product',
          name: 'Plumbing Essentials',
          description: 'CPVC pipes, PVC pipes, fittings, valves, water tanks',
          brand: ['Astral', 'Supreme', 'Prince']
        }
      }
    ]
  },
  faq: {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'What products are available at Bombay Home Gallery?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'We offer premium tiles (vitrified, ceramic, floor, wall, kitchen, bathroom), bathroom fittings (washbasins, toilets, vanities, CP fittings), and plumbing essentials (CPVC pipes, PVC pipes, fittings) from top brands like Astral, Birla Opus, Parryware, and more.'
        }
      },
      {
        '@type': 'Question',
        name: 'Where is Bombay Home Gallery located in Lucknow?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Our showroom is located at Hardoi Road, opposite Azad patakhe, Haji Colony, Mahipatmau, Lucknow, Uttar Pradesh 226003. We are open all days from 10 AM to 8:30 PM.'
        }
      },
      {
        '@type': 'Question',
        name: 'Do you provide home consultation services?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yes, we provide free expert consultation from our founder Akhand Pratap, a Civil Engineer with Master\'s in Construction Management. You can visit our showroom or contact us at 9321233008 for guidance.'
        }
      },
      {
        '@type': 'Question',
        name: 'What brands are available at Bombay Home Gallery?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'We stock products from leading brands including Astral Pipes, Birla Opus, Roff, Parryware, Plumber Bathware, Supreme Pipes, Kajaria, Hindware, and many more premium brands.'
        }
      }
    ]
  },
  breadcrumb: (pageName, pageUrl) => ({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://bombayhomegallery.com'
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: pageName,
        item: `https://bombayhomegallery.com${pageUrl}`
      }
    ]
  })
};

// Keywords for different product categories
export const productKeywords = {
  tiles: [
    'vitrified tiles lucknow',
    'ceramic tiles lucknow',
    'floor tiles lucknow',
    'wall tiles lucknow',
    'bathroom tiles lucknow',
    'kitchen tiles lucknow',
    'outdoor tiles lucknow',
    'marble look tiles',
    'wooden look tiles',
    'designer tiles lucknow',
    'anti-skid tiles',
    'parking tiles lucknow',
    'elevation tiles lucknow',
    'best tiles shop lucknow'
  ],
  bathroom: [
    'bathroom fittings lucknow',
    'washbasin lucknow',
    'toilet seat lucknow',
    'western toilet lucknow',
    'indian toilet lucknow',
    'bathroom vanity lucknow',
    'cp fittings lucknow',
    'taps and faucets lucknow',
    'shower fittings lucknow',
    'bathroom accessories lucknow',
    'sanitary ware lucknow',
    'parryware dealer lucknow',
    'hindware dealer lucknow'
  ],
  plumbing: [
    'plumbing shop lucknow',
    'cpvc pipes lucknow',
    'pvc pipes lucknow',
    'astral pipes lucknow',
    'supreme pipes lucknow',
    'pipe fittings lucknow',
    'plumbing materials lucknow',
    'water tank lucknow',
    'bathroom plumbing',
    'kitchen plumbing'
  ]
};
